export const WebUiPaymentAccountBalanceEnI18n = {
    title: 'Account Balance',
    prefix: 'Current balance:',
    hint: 'Fund your account',
};
